import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api/api";
import Layout from "../components/Layout";
import "../styles/EditInterview.css"; // Keep your custom styles

export default function EditInterview() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [interview, setInterview] = useState({
    company: "",
    position: "",
    date: "",
    status: "",
    notes: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get(`/interviews/${id}`)
      .then((res) => {
        const fetched = res.data;
        setInterview({
          ...fetched,
          date: fetched.date ? fetched.date.split("T")[0] : "",
        });
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch interview", err);
        setError("Failed to load interview details.");
        setLoading(false);
      });
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInterview((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/interviews/${id}`, interview);
      // Navigate back to interviews after successful update
      navigate("/interviews");
    } catch (err) {
      console.error("Update failed:", err.response?.data || err.message);
      setError("Failed to update interview. Please try again.");
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="edit-container">
          <div className="edit-card">Loading interview details...</div>
        </div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <div className="edit-container">
          <div className="edit-card error">{error}</div>
          <button className="btn secondary" onClick={() => navigate("/interviews")}>
            Back to Interviews
          </button>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="edit-container">
        <div className="edit-card">
          <h2 className="edit-title">Edit Interview</h2>
          <form onSubmit={handleSubmit} className="edit-form">
            <label>
              Company
              <input
                type="text"
                name="company"
                value={interview.company}
                onChange={handleChange}
                required
              />
            </label>

            <label>
              Position
              <input
                type="text"
                name="position"
                value={interview.position}
                onChange={handleChange}
                required
              />
            </label>

            <label>
              Date
              <input
                type="date"
                name="date"
                value={interview.date}
                onChange={handleChange}
                required
              />
            </label>

            <label>
              Status
              <select
                name="status"
                value={interview.status}
                onChange={handleChange}
                required
              >
                <option value="">Select Status</option>
                <option value="Pending">Pending</option>
                <option value="Scheduled">Scheduled</option>
                <option value="Completed">Completed</option>
                <option value="Cancelled">Cancelled</option>
              </select>
            </label>

            <label>
              Notes
              <textarea
                name="notes"
                value={interview.notes || ""}
                onChange={handleChange}
                rows="4"
              />
            </label>

            <div className="edit-buttons">
              <button type="submit" className="btn primary">
                Update
              </button>
              <button
                type="button"
                className="btn secondary"
                onClick={() => navigate("/interviews")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
}
